module.exports = __webpack_public_path__ + "static/media/Cassie-Casperson_160px.8a49d405.jpg";